import { FormControl, Grid, Typography } from '@material-ui/core';
import React, { FC, memo } from 'react';
import { WrappedFieldProps } from 'redux-form';

import StandardSlider from '../../Slider/Slider';
import inputStyles from '../styles';
import componentStyles from './styles';

export interface SliderProps extends WrappedFieldProps {
  isRange?: boolean;
  max: number;
  min: number;
  step?: number;
  toggleIsRange?: () => void;
}

export const Slider: FC<SliderProps> = props => {
  const classes = {
    ...inputStyles(props),
    ...componentStyles(),
  };

  const {
    input: { name, value, onChange },
    max,
    min,
    step,
    toggleIsRange,
    isRange,
  } = props;
  let sliderValue;

  if (!Array.isArray(value)) {
    sliderValue = Number(value);
  } else {
    sliderValue = [Number(value[0]), Number(value[1])];
  }

  return (
    <FormControl className={classes.formControl}>
      <Grid container justify="space-between">
        <Typography className={classes.header} variant="body2">
          Pay
        </Typography>
        <button className={classes.togglePayRange} onClick={toggleIsRange} type="button">
          {isRange ? 'Switch to fixed' : 'Switch to range'}
        </button>
      </Grid>
      <Grid alignItems="center" className={classes.sliderContainer} container>
        <StandardSlider max={max} min={min} onChange={(e, v) => onChange(v)} step={step} value={sliderValue} />
      </Grid>
    </FormControl>
  );
};

export default memo(Slider);
